module.exports = __webpack_public_path__ + "img/nav-design-fancy.7a7d128.webp";